import React, { useEffect, useState } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import axios from 'axios';
import { Modal, Container, Row, Col, ButtonToolbar, Button, Form} from 'react-bootstrap';
import { CONFIG_VEHICULAR_OPTIONS, SUBTIPO_REM_OPTIONS, configRequiresTrailer } from '../unitCatalogs';

function DefaultModal(props) {
        const apiUrl = process.env.REACT_APP_URL;
    const authHeader = useAuthHeader();
        const [equipmentRole, setEquipmentRole] = useState('power_unit');
        const [configVehicular, setConfigVehicular] = useState('');

        useEffect(() => {
            if (props.show) {
                setEquipmentRole('power_unit');
                setConfigVehicular('');
            }
        }, [props.show]);

        const handleButtonClick = (event) => {
            event.preventDefault();
            const isTrailer = equipmentRole === 'trailer';
            const data = {'name': event.target.name.value,
                'plates': event.target.plates.value,
                'inventory_type': isTrailer ? 'Remolque' : 'Autotransporte',
                'equipment_role': equipmentRole,
                'requires_trailer': configRequiresTrailer(event.target.config_vehicular?.value),
                'subtipo_rem': event.target.subtipo_rem?.value || null,
                'make': event.target.make.value,
                'axles': event.target.axles.value,
                'model': event.target.model.value,
                'year': event.target.year.value,
                'config_vehicular': isTrailer ? null : event.target.config_vehicular?.value || null,
                'peso_bruto_vehicular': parseFloat(event.target.peso_bruto_vehicular?.value) || null,
                'permiso_sct': event.target.permiso_sct?.value || null,
                'num_permiso_sct': event.target.num_permiso_sct?.value || null,
                'aseguradora_resp_civil': event.target.aseguradora_resp_civil?.value || null,
                'poliza_resp_civil': event.target.poliza_resp_civil?.value || null}
            axios({
                method:'POST',
                url:apiUrl+'/units/unit',
            headers: {
                Authorization: authHeader()
            },
                data: data
            }).then(response => {
                console.log(response);
                props.onHide();
            })
            .catch(error => {
                console.log(error);
                alert(error);
            });
        }
        return (
            <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Agregar Unidad
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container>
                        <Form onSubmit={handleButtonClick}>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="name">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                                <Form.Group as={Col} controlId="plates">
                                    <Form.Label>Placa</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="equipment_role">
                                    <Form.Label>Tipo de Equipo</Form.Label>
                                    <Form.Select
                                        value={equipmentRole}
                                        onChange={(event) => {
                                            const value = event.target.value;
                                            setEquipmentRole(value);
                                            if (value === 'trailer') {
                                                setConfigVehicular('');
                                            }
                                        }}
                                    >
                                        <option value="power_unit">Autotransporte</option>
                                        <option value="trailer">Remolque</option>
                                    </Form.Select>
                                </Form.Group>
                                {equipmentRole === 'trailer' && (
                                    <Form.Group as={Col} controlId="subtipo_rem">
                                        <Form.Label>Subtipo de Remolque</Form.Label>
                                        <Form.Select defaultValue="">
                                            <option value="">Seleccionar...</option>
                                            {SUBTIPO_REM_OPTIONS.map(([value, label]) => (
                                                <option key={value} value={value}>{label}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                )}
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="make">
                                    <Form.Label>Marca</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                                <Form.Group as={Col} controlId="model">
                                    <Form.Label>Modelo</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                                <Form.Group as={Col} controlId="year">
                                    <Form.Label>Año</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                                <Form.Group as={Col} controlId="axles">
                                    <Form.Label>Ejes</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                            </Row>
                            {equipmentRole !== 'trailer' && (
                            <>
                            <Row className="mb-3">
                                <h6>SAT / Carta Porte</h6>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="config_vehicular">
                                    <Form.Label>Configuración Vehicular</Form.Label>
                                    <Form.Select
                                        value={configVehicular}
                                        onChange={(event) => setConfigVehicular(event.target.value)}
                                    >
                                        <option value="">Seleccionar...</option>
                                        {CONFIG_VEHICULAR_OPTIONS.map(([value, label]) => (
                                            <option key={value} value={value}>{label}</option>
                                        ))}
                                    </Form.Select>
                                    {configRequiresTrailer(configVehicular) && (
                                        <Form.Text>Esta configuración requiere seleccionar remolque en el viaje.</Form.Text>
                                    )}
                                </Form.Group>
                                <Form.Group as={Col} controlId="peso_bruto_vehicular">
                                    <Form.Label>Peso Bruto Vehicular (Ton)</Form.Label>
                                    <Form.Control type="number" step="0.01" min="0" placeholder="0.00" />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="permiso_sct">
                                    <Form.Label>Tipo de Permiso</Form.Label>
                                    <Form.Select defaultValue="">
                                        <option value="">Seleccionar...</option>
                                        <option value="TPAF01">TPAF01 - Autotransporte Federal de carga general</option>
                                        <option value="TPAF02">TPAF02 - Transporte privado de carga</option>
                                        <option value="TPAF03">TPAF03 - Carga Especializada de materiales peligrosos</option>
                                        <option value="TPAF04">TPAF04 - Transporte de carga de uso exclusivo</option>
                                        <option value="TPAF09">TPAF09 - Doblemente Articulado</option>
                                        <option value="TPAF19">TPAF19 - Servicio de Paquetería y Mensajería</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} controlId="num_permiso_sct">
                                    <Form.Label>Número de Permiso</Form.Label>
                                    <Form.Control placeholder="Número de permiso SCT" />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="aseguradora_resp_civil">
                                    <Form.Label>Aseguradora Resp. Civil</Form.Label>
                                    <Form.Control placeholder="Nombre de la aseguradora" />
                                </Form.Group>
                                <Form.Group as={Col} controlId="poliza_resp_civil">
                                    <Form.Label>Póliza Resp. Civil</Form.Label>
                                    <Form.Control placeholder="Número de póliza" />
                                </Form.Group>
                            </Row>
                            </>
                            )}
                            {/* <Row className="mb-3">
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>Fotos de la unidad</Form.Label>
                                <Form.Control type="file" />
                            </Form.Group>
                            </Row> */}
                            <Button type="submit" value="Submit">Guardar</Button>
                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
        );
}

class ModalWithGrid extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = { modalShow: false };
    }

    render() {
        let add_new_unit = () => {this.props.setData(); this.setState({ modalShow: false });}
        return (
            <ButtonToolbar>
                <Button
                    variant="primary"
                    onClick={() => this.setState({ modalShow: true })}
                >
                    Agregar Unidad
                </Button>
                <DefaultModal show={this.state.modalShow} onHide={add_new_unit} />
            </ButtonToolbar>
        );
    }
}

export default ModalWithGrid;
